// extracted by mini-css-extract-plugin
export default {"main_container":"styles_main_container__f1hgf","actions_container":"styles_actions_container__i2Zi9"};